/**
 *
 */
export enum EnrollmentType {
    Brand,
    Campaign,
    SmsNumber
}
